import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';
import {useSelector} from 'react-redux';

import LoaderSpinner from 'components/elements/LoaderSpinner';
import usePipelines from 'hooks/pipelines/use-pipelines';
import InfiniteLoaderList from 'components/elements/InfiniteLoadList';
import AlertCard from 'components/elements/AlertCard';

import PipelineCard from './pipeline-card';

const PipelinesList = ({
                           datasetId,
                           height,
                           filters = {
                               search: '',
                               status: '',
                               type: '',
                               pipeline_run_id: '',
                               experiment_id: '',
                           }
                       }) => {
    const [flattenedRuns, setFlattenedRuns] = useState([]);
    const pipeline_notifications = useSelector((state) => state.app.pipeline_notifications);

    const {data, isFetchingNextPage, hasNextPage, fetchNextPage, isError, status} = usePipelines({
        filters,
        datasetId
    });

    useEffect(() => {
        if (data) {
            setFlattenedRuns(
                data.pages.reduce((accum, curr) => {
                    return [...accum, ...curr.data];
                }, []))
        }
    }, [data])

    // Update pipeline runs when notifications change
    useEffect(() => {
        console.log("Pipeline notifications updated:", pipeline_notifications);
        console.log("flattenedRuns updated:", flattenedRuns);
        if (pipeline_notifications.length > 0 && flattenedRuns.length > 0) {
            // Get the latest notification
            const latestNotification = pipeline_notifications[pipeline_notifications.length - 1];

            // Check if the notification contains pipeline run data
            if (latestNotification && latestNotification.trace_id && latestNotification.level) {
                const { trace_id, level } = latestNotification;
                const notificationStatus = level.toUpperCase();
                if (notificationStatus === 'ERROR' || notificationStatus=== 'SUCCESS') {
                    setFlattenedRuns(prevRuns =>
                      prevRuns.map(run =>
                        run.run_id === trace_id
                          ? { ...run, status:notificationStatus }
                          : run
                      )
                    );
                }

            }
            console.log("Updated flattenedRuns:", flattenedRuns);
        }
    }, [pipeline_notifications, flattenedRuns.length])

    if (status === 'loading') {
        return <Grid container justifyContent="center" alignItems="center" sx={{width: '100%', height: height - 24}}>
            <Grid item>
                <LoaderSpinner type="Bars" color="#175da8" secondaryColor={"#6abed5"} height={70} width={70}/>
            </Grid>
        </Grid>
    }

    if (status === 'error') {
        return <AlertCard severity={'error'} height={height - 24} message={'Something went wrong !'}/>;
    }

    if (flattenedRuns) {
        if (flattenedRuns.length > 0) {
            return (
                <>
                    <InfiniteLoaderList
                        height={height - 20}
                        data={flattenedRuns}
                        isFetchingNextPage={isFetchingNextPage}
                        hasNextPage={hasNextPage}
                        fetchNextPage={fetchNextPage}
                        isError={isError}
                        itemTemplate={PipelineCard}
                    />
                </>
            );
        } else {
            return <AlertCard severity={'info'} height={height - 24} message={'No data available !'}/>;
        }
    }
};

export default PipelinesList;
